export function showError(err) {
  const msg = err.message || err;

  alert(msg);
  console.error(err);
}
